import { RemoteCreateEntities } from 'data/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateEntities = (): RemoteCreateEntities => {
  return new RemoteCreateEntities(makeApiUrlEntities(), makeAxiosHttpClient());
};
